var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RoyImage"},[_c('StyledImage',_vm._b({},'StyledImage',_vm.style,false),[_c('img',{attrs:{"alt":_vm.element.title || 'RoyImage',"src":_vm.element.src}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }